import { qrCodeButtonsData } from "conts/QrCodeButtonData"
import { routesPath } from "conts/routes"
import { useEffect } from "react"
import { useMediaQuery } from "react-responsive"
import { useNavigate } from "react-router-dom"
import LoginRootImage from "static/pictures/welcome_page.png"
import styled from "styled-components"
import { ButtonPrimary } from "ui/base/Button/ButtonStyled"
import { HelperText } from "ui/base/helperText/HelperText"
import { themeColor, themeFontSize } from "ui/theme"
import { pixelTrackEvent } from "utils/facebookPixel"

export const Welcome = ({
    children,
    showHeader = true,
    autoHeight = false,
}) => {
    useEffect(() => {
        pixelTrackEvent("Enter Welcome Instructor Page")
    }, [])

    const navigate = useNavigate();

    const isMobile = useMediaQuery({ query: "(max-width: 768px)" })

    return (
        <>
            <AppRootContainer bgColor={"white"} autoHeight={autoHeight}>
                <CircleDiv></CircleDiv>
                <section className={`center-instrutor-signup instrutor-signup`}>
                    <div id='msform'>
                        <div className='container'>
                            <fieldset>
                                <>
                                    <WelcomeLeftContainer>
                                        <WelcomeTextContainer>
                                            <HelperText size='large' sizeMobile='big' weight={600}>
                                                Thank you for your submission!
                                            </HelperText>
                                            <HelperText>
                                                Our team will review your application and notify you
                                                shortly if your class is approved or if any changes are
                                                needed.
                                            </HelperText>
                                            <HelperText>
                                                Download the app, and once your submission is approved,
                                                you will be able to review, manage your class, and start accepting
                                                students from your phone!
                                            </HelperText>
                                            <HelperText weight={600}>
                                                If you have any questions, please reach out at{" "}
                                                <HelperText weight={600} color='blue'>
                                                    <a href='mailto:hello@teache.co'>hello@teache.co</a>
                                                </HelperText>
                                                .
                                            </HelperText>

                                            <ButtonPrimary
                                                variant="primary_fade"
                                                style={isMobile ? {
                                                    marginTop: "1rem",
                                                    // marginInline: 'auto',
                                                    width: "auto"
                                                } : {
                                                    marginTop: "1rem",
                                                    width: "40%"
                                                }}
                                                onClick={() => navigate(routesPath.main)}
                                            >
                                                Return to the Homepage
                                            </ButtonPrimary>
                                        </WelcomeTextContainer>
                                        <WelcomeRowContainer>
                                            <WelcomeButtonContainer>
                                                {qrCodeButtonsData?.map((item) => (
                                                    <QrCodeButton
                                                        key={item.text}
                                                        qrcode={item.qrcode}
                                                        href={item.href}
                                                        icon={item.icon}
                                                        title={item.text}></QrCodeButton>
                                                ))}
                                            </WelcomeButtonContainer>
                                        </WelcomeRowContainer>
                                    </WelcomeLeftContainer>
                                </>

                                <div className='phone-image'>
                                    <img src={LoginRootImage} />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </section>
            </AppRootContainer>
        </>
    )
}

const QrCodeButton = (props) => {
    const {
        icon,

        title,
        qrcode,
        ...rest
    } = props
    return (
        <WelcomeQrCodeContainer target='_blank' {...rest}>
            <WelcomeQrCodeTitle>
                {icon && icon}

                <HelperText color='white' sizeMobile='small' weight={600}>
                    {title}
                </HelperText>
            </WelcomeQrCodeTitle>
            <WelcomeQrCode>
                <img src={qrcode} alt='qrcode' loading='lazy' />
            </WelcomeQrCode>
            <HelperText color='white' weight={600} className='scanMe'>
                SCAN ME
            </HelperText>
        </WelcomeQrCodeContainer>
    )
}

const AppRootContainer = styled.div`
    padding-block: 0px;
    overflow: hidden;
    position: relative;
    background-color: ${themeColor("white")};
`
const CircleDiv = styled.div`
    position: absolute;
    width: 50vw;
    height: 50vw;
    background: linear-gradient(135.32deg, #8268fc 0%, #4fd0e3 100.57%);
    border-radius: 999px;
    bottom: -35vw;
    left: 10vw;
    opacity: 0.2;
    display: none;
    @media (min-width: 1280px) {
        display: grid;
    }
`

const WelcomeRowContainer = styled.div`
    display: grid;
    place-items: center;
    gap: 1rem;
    @media (min-width: 768px) {
        place-items: start;
    }
`

const WelcomeLeftContainer = styled.div`
    display: grid;
    gap: 50px;
    margin-inline: auto;
    margin-top: 2dvh;
    @media (min-width: 768px) {
        margin-top: 0px;
    }
`

const WelcomeTitleContainer = styled.div`
    display: grid;
    gap: 30px;
    max-width: 625px;
`

const WelcomeTextContainer = styled.div`
    display: grid;
    gap: 1.2rem;
    max-width: 625px;
`

const WelcomeButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    @media (min-width: 768px) {
        justify-content: flex-start;
    }
`

const WelcomeQrCodeContainer = styled.a`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    white-space: nowrap;
    color: ${themeColor("white")};
    font-size: ${themeFontSize("regular")};
    border-radius: 10px;
    background: ${themeColor("blue")};
    padding: 10px;
    gap: 1rem;

    & > .scanMe {
        display: none;
    }

    @media (min-width: 768px) {
        padding: 20px;

        & > .scanMe {
            display: block;
        }
    }
`

const WelcomeQrCode = styled.div`
    bottom: 100%;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    background: ${themeColor("blue")};
    width: 100%;
    display: none;
    align-items: center;
    justify-content: center;

    & > img {
        width: 130px;
        height: auto;
    }

    @media (min-width: 768px) {
        display: flex;
    }
`

const WelcomeQrCodeTitle = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    white-space: nowrap;
    border-radius: 10px;
    background: ${themeColor("blue")};

    svg {
        margin-right: 10px;
        width: 31px;
        min-width: 31px;
    }
`

const WelcomeImageContainer = styled.div`
    position: relative;
    justify-content: center;
    align-items: center;
    display: none;
    @media (min-width: 1024px) {
        display: flex;
    }
`
const WelcomeImg = styled.img`
    position: absolute;
    right: -70%;
    @media (min-width: 1024px) {
        right: -50%;
    }
`
